export default __webpack_public_path__ + "static/media/antares-clinica.26c6111d.png";